// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dr-header[data-v-01269606]{position:relative;background:#fff;-webkit-box-shadow:0 4px 4px rgba(0,0,0,.16);box-shadow:0 4px 4px rgba(0,0,0,.16);padding:1rem 1.6rem;z-index:99}", ""]);
// Exports
module.exports = exports;
